/* tslint:disable */
/* eslint-disable */
/**
 * NoorWriter API
 * API for NoorWriter Chrome extension - AI writing assistant
 *
 * The version of the OpenAPI document: v1
 * Contact: contact@noorways.fr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from './configuration'
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios'
import appSettings from '@/config/appSettings'
import axios from 'axios'
import type { AxiosError } from 'axios'
import { useAuthentication } from '@/authentication/AuthenticationManager'
import { handleHttpError, handleHttpSuccess } from '@/api/http'

export const BASE_PATH = appSettings.BACKEND_URL

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
  csv: ',',
  ssv: ' ',
  tsv: '\t',
  pipes: '|',
}

/**
 *
 * @export
 * @interface RequestArgs
 */
export interface RequestArgs {
  url: string
  options: AxiosRequestConfig
}

export interface RequestConfig extends AxiosRequestConfig {
  showNotificationOnSuccess?: boolean
  showNotificationOnError?: boolean
}

const getBasePath = (): string => {
  return appSettings.BACKEND_URL
}

const getToken = async (): Promise<string> => {
  const { accessToken } = useAuthentication()
  return Promise.resolve(accessToken.value ?? '')
}

export const BackendConfiguration = new Configuration({
  accessToken: getToken,
})

/**
 * Unauthenticated configuration for endpoints that don't require authentication
 * Used for endpoints like exchange-redirect-token that should not include Bearer tokens
 */
export const UnauthenticatedBackendConfiguration = new Configuration({
  // No accessToken provided - requests will not include Authorization headers
})

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
  protected configuration: Configuration | undefined
  protected axios: AxiosInstance
  protected basePath: string | undefined

  constructor(configuration: Configuration = BackendConfiguration) {
    if (configuration) {
      this.configuration = configuration
      this.basePath = getBasePath()
    }
    this.axios = this.createAxiosInstance(this.configuration)
  }

  createAxiosInstance(_configuration?: Configuration): AxiosInstance {
    const instance = axios.create()
    instance.interceptors.response.use(
      // On success
      (response) => {
        const config = response.config as RequestConfig
        const showNotificationOnSuccess =
          config.showNotificationOnSuccess ?? config.method !== 'get'
        if (showNotificationOnSuccess) {
          handleHttpSuccess()
        }
        return response
      },
      // On error
      (error: AxiosError) => {
        const config = error.config as RequestConfig
        if (config.showNotificationOnError !== false) {
          handleHttpError(error)
        }
        throw error
      }
    )
    return instance
  }
}

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
  name: 'RequiredError' = 'RequiredError'
  constructor(
    public field: string,
    msg?: string
  ) {
    super(msg)
  }
}
